(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miroin-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.miroin-header a');
    if (link) link.closest('.miroin-header').querySelectorAll('details[open]').forEach((menu) => menu.removeAttribute('open'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const menu = event.target.closest('.miroin-header details[open]');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["miroin-product"]) return;
  try {
    
function localizeMiroinDescription(root) {
  const isChinese = (root.dataset.locale || '').toLowerCase().startsWith('zh');
  const content = Array.from(root.children).filter((element) => element.tagName !== 'H2');
  const hasChinese = (value) => /[\u3400-\u9fff]/.test(value);
  let visibleNarrative = 0;

  content.forEach((element) => {
    const text = element.textContent.trim();
    const artist = text.match(/^Artist\s*\/[^：:]*[：:]\s*([A-Za-z ]+)\s*([\u3400-\u9fff]+)(?:\s*Reference\s*\/[^：:]*[：:]\s*(.+))?$/i);
    const reference = text.match(/^Reference\s*\/[^：:]*[：:]\s*(.+)$/i);
    const artwork = text.match(/^Artwork\s*\/[^：:]*[：:]\s*(\d+\s*×\s*\d+\s*cm)/i);

    if (artist) {
      const referenceLine = artist[3] ? `<br>${isChinese ? '作品编号' : 'Reference'}：${artist[3]}` : '';
      element.innerHTML = `${isChinese ? '艺术家' : 'Artist'}：${isChinese ? artist[2] : artist[1].trim()}${referenceLine}`;
      return;
    }
    if (reference) {
      element.textContent = isChinese ? `作品编号：${reference[1]}` : `Reference: ${reference[1]}`;
      return;
    }
    if (artwork) {
      element.textContent = isChinese ? `画心：${artwork[1].replace(/cm/i, '厘米')}，不含框` : `Artwork: ${artwork[1]}, excluding frame`;
      return;
    }
    if (text.startsWith('Framed interior images') && text.includes(' / ')) {
      const halves = text.split(' / ');
      element.textContent = isChinese ? halves[halves.length - 1] : halves[0];
      return;
    }

    const matchesLocale = isChinese ? hasChinese(text) : !hasChinese(text);
    element.hidden = !matchesLocale;
    if (matchesLocale) visibleNarrative += 1;
  });

  if (visibleNarrative === 0) content.forEach((element) => { element.hidden = false; });
}

document.querySelectorAll('[data-mp-description]').forEach(localizeMiroinDescription);
document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('[data-mp-thumbnail]');
  if (thumbnail) {
    const gallery = thumbnail.closest('.mp-gallery');
    const stageImage = gallery.querySelector('[data-mp-zoom] img');
    const zoomButton = gallery.querySelector('[data-mp-zoom]');
    gallery.querySelectorAll('[data-mp-thumbnail]').forEach((item) => item.setAttribute('aria-current', String(item === thumbnail)));
    stageImage.src = thumbnail.dataset.imageUrl;
    stageImage.srcset = '';
    stageImage.alt = thumbnail.dataset.imageAlt;
    zoomButton.dataset.zoomUrl = thumbnail.dataset.zoomUrl;
    return;
  }
  const zoomButton = event.target.closest('[data-mp-zoom]');
  if (zoomButton) {
    const gallery = zoomButton.closest('.mp-gallery');
    const dialog = gallery.querySelector('[data-mp-lightbox]');
    const lightboxImage = dialog.querySelector('[data-mp-lightbox-image]');
    const stageImage = zoomButton.querySelector('img');
    lightboxImage.src = zoomButton.dataset.zoomUrl;
    lightboxImage.alt = stageImage.alt;
    dialog.showModal();
    return;
  }
  const dialog = event.target.closest('[data-mp-lightbox]');
  if (dialog && event.target === dialog) dialog.close();
});

  } catch(e) { console.error(e); }
})();
})();
